<template>
  <div v-if="$canAndRulesPass(user, 'use_connection_year.see_in_menu')">

    <page-heading
      heading="История по годам"
    >
      <span slot="help"></span>
      <span slot="right"></span>
    </page-heading>

    <el-table
      :data="years"
      style="width: 500px"
      v-loading="loading"
    >
      <el-table-column label="Год" v-slot="scope">
        <el-date-picker
          v-model="scope.row.year"
          style="width:100%"
          type="year"
          value-format="yyyy"
          @input="saveYear(scope.row)"
        >
        </el-date-picker>
      </el-table-column>
      <el-table-column label="Дата" v-slot="scope">
        <el-date-picker
          style="width:100%"
          v-model="scope.row.date"
          :picker-options="{firstDayOfWeek: 1}"
          type="date"
          value-format="yyyy-MM-dd"
          format="dd.MM.yyyy"
          @input="saveYear(scope.row)"
        >
        </el-date-picker>
      </el-table-column>
      <el-table-column width="70" align="center" v-slot="scope">
        <el-popconfirm
          confirm-button-text='Да'
          cancel-button-text='нет'
          icon="el-icon-question"
          title="Вы уверены, что хотите удалить строку?"
          @confirm="deleteYear(scope.row)"
        >
          <el-button
            class="table-action-button"
            slot="reference"
            size="mini"
            round
            :loading="loading"
            icon="far fa-trash-alt"
          >
          </el-button>
        </el-popconfirm>
      </el-table-column>
    </el-table>

    <el-button
      style="margin-top: 10px"
      icon="fas fa-plus"
      @click="addYear"
    >
      Добавить
    </el-button>
  </div>
</template>

<script>
import PageHeading from "@/components/PageHeading.vue";
import ClickToEdit from "@/components/ClickToEdit.vue";
import requestSender from "@/api/base/requestSender";
import { mapGetters } from "vuex";

export default {
  name: "use-connection-year",
  components: {
    ClickToEdit,
    PageHeading,

  },
  props: {},
  mounted() {
    this.loadYears()
  },
  computed: {
    ...mapGetters(['user']),
  },
  data() {
    return {
      loading: false,
      years: [],
    }
  },
  methods: {
    loadYears() {
      this.loading = true;

      requestSender('get', 'use-connection-year/search', {})
        .then((data) => {
          this.years = data.years;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addYear() {
      this.years.push({});
    },
    saveYear(year) {
      this.loading = true;

      requestSender('post', 'use-connection-year/save', {
        id: year.id,
        year: year.year,
        date: year.date,
      })
        .then(data => {
          this.$notify.success({
            title: 'Сохранено',
            message: 'Год успешно сохранен'
          });
        })
        .finally(() => {
          this.loadYears();
        });
    },
    deleteYear(year) {
      this.loading = true;

      requestSender('post', 'use-connection-year/delete', {
        id: year.id,
      })
        .then(data => {
          this.$notify.success({
            title: 'Сохранено',
            message: 'Год успешно удален'
          });
        })
        .finally(() => {
          this.loadYears();
        });
    },
  }
}
</script>

<style>
</style>
